import { render, staticRenderFns } from "./PMCS.vue?vue&type=template&id=188856a4&scoped=true&"
import script from "./PMCS.vue?vue&type=script&lang=js&"
export * from "./PMCS.vue?vue&type=script&lang=js&"
import style0 from "./PMCS.vue?vue&type=style&index=0&id=188856a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188856a4",
  null
  
)

export default component.exports